export interface LAIAPhysicalMapping {
  capabilityId: 'components.repair_supervised'
  physicalLocator: string
  operationType: 'MODIFY_TEXT_FILE'
  newContent: string
}

const WORKSPACE_PREFIX =
  '/opt/sei/genesis-clean/state/workspace/'

export function buildControlledWorkspaceMapping(
  physicalLocator: string,
  newContent: string,
): LAIAPhysicalMapping {
  const normalized =
    physicalLocator.trim()

  if (
    !normalized ||
    !normalized.startsWith(
      WORKSPACE_PREFIX,
    )
  ) {
    throw new Error(
      'El target físico debe pertenecer al WORKSPACE certificado.',
    )
  }

  if (
    typeof newContent !== 'string' ||
    newContent.length === 0
  ) {
    throw new Error(
      'El nuevo contenido no puede estar vacío.',
    )
  }

  return {
    capabilityId:
      'components.repair_supervised',

    physicalLocator:
      normalized,

    operationType:
      'MODIFY_TEXT_FILE',

    newContent,
  }
}
